export default {
  hasItems: (data) => {
    return data.cart.items.length > 0
  },
  showCount: (data,state,view) => {
    var count = data.cart.items.length;

    if(count == 0) return `(0 Items)`;
    if(count == 1) return `(1 Item)`;
    return `(${count} Items)`;
  },
  showItemCount: (data) => {
    return data.cart.items.length
  },
  showItemTitle: (s,v,li) => {
    var line_price = li.price * li.quantity;
    var vendor = (li.vendor != "") ? li.vendor : false;
    var title  = li.product_title;
    var price  = v.currency.showPrice(s,v, {
      price: line_price,
    });

    return (vendor) ? `<span class="vendor">${vendor}</span>, ${title}, ${price}` : `${title}, ${price}`;
  },
  showItemPrice: (s,v,li) => {
    return v.currency.showMoney(s,li.price);
  }
}